import React, { useEffect, useState } from 'react';
import {
  AppstoreOutlined,
  ArrowRightOutlined,
  BarsOutlined,
  BookOutlined,
  CalendarOutlined,
  CopyOutlined,
  CarryOutOutlined,
  DollarOutlined,
  SnippetsOutlined,
  FormOutlined,
  HomeFilled,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  OrderedListOutlined,
  PlusCircleOutlined,
  ProjectOutlined,
  QuestionCircleOutlined,
  StarOutlined,
  ToolOutlined,
  UserOutlined,
  FileSearchOutlined,
  ScheduleOutlined,
} from '@ant-design/icons';
import type { MenuProps } from 'antd';
import LoadingOverlay from 'react-loading-overlay-ts';
import { Anchor, Button, Card, ConfigProvider, Dropdown, Flex, FloatButton, Layout, Menu, Modal, theme } from 'antd';  
import { Outlet, useLocation, useParams} from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { FontBackgroundColor } from 'ckeditor5';
import R from './picture/LOGOVU.png'
const { Header, Sider, Content } = Layout;




const siderStyle: React.CSSProperties = {
  height: '100vh',
  position: 'fixed',
  left: 0,
  top: 0,
  bottom: 0,
  zIndex: 1000, // Ensure it stays above the content
  overflow: 'auto',
  scrollbarWidth: 'thin',
};

//รายการในsider
const Navbar: React.FC = () => {
  
  const handleMain = () => {
    navigate(`/VRIIS`);
  };

  const [Approved,SetApproved]=useState(false)
  const [IsStudent,setIsStudent]=useState(false)
  const [isActive, setActive] = useState(true)
  
  //ออกจากระบบ
  function signout() {
    sessionStorage.clear();
    window.location.href = "/VRIIS/";
  }

  const [imgdata,setimg] = useState();
  const [openMod,setopenMod] = useState(false)

  type MenuItem = Required<MenuProps>['items'][number];

  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const MenuKey = location.pathname;
  const navigate = useNavigate();
  
  
  const { project_id,ProgressReportID } = useParams();
  // Check if the current path is 'BudgetReqFund'
  const isBudgetReqInfo = location.pathname === `/VRIIS/BudgetReqInfo/${project_id}`;
  const isBudgetReqDetail = location.pathname === `/VRIIS/BudgetReqDetail/${project_id}`;
  const isHome = location.pathname === `/VRIIS`
  const isHome2 = location.pathname === `/VRIIS/`
  const isDraft = location.pathname === `/VRIIS/BudgetReqDraft`
  const IsProgressReport = location.pathname === `/VRIIS/ProgressReport/${project_id}`
  const IsProgressReport2 = location.pathname ===  `/VRIIS/ProgressReport/${project_id}/${ProgressReportID}}`
  const IsProgressCheckReport = location.pathname === `/VRIIS/ProgressReportCheck/${project_id}`
  const IsProgressReportEdit = location.pathname.includes('/VRIIS/ProgressReportEdit/')
  const IsCompletionReport = location.pathname === `/VRIIS/CompletionReport/${project_id}`
  const IsCompletionCheckReport = location.pathname === `/VRIIS/CompletionReportCheck/${project_id}`

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const onclickManual = async()=>{
    window.open('https://www.canva.com/design/DAGaFLPGDAA/unmMR-syskcOPtY89srNtQ/view?utm_content=DAGaFLPGDAA&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=hf0938878eb', '_blank');
  }

  const handleCheckUpdated = () => {
    navigate(`/VRIIS/ProgressReportCheck/${project_id}`);
  };
  const handleComplete = () => {
    navigate(`/VRIIS/CompletionReport/${project_id}`);
  };
  const handleCheckComplete = () => {
    navigate(`/VRIIS/CompletionReportCheck/${project_id}`);
  };

  const items: MenuItem[] = [
    { key: '/VRIIS', icon: <HomeFilled />, label: <a onClick={handleMain} target="_self" rel="noopener noreferrer">: หน้าหลัก</a> },
    {key: '/Help', icon: <QuestionCircleOutlined />, label: <a onClick={onclickManual} target="_self" rel="noopener noreferrer">: คู่มือการใช้งาน</a>},
    { key: '/logout', icon: <LogoutOutlined />, label: <a onClick={()=>setopenMod(true)}>: ออกจากระบบ</a> },
  ];
  let Infoitems = 
    ([
      { key: '/VRIIS', icon: <HomeFilled />, label: <a onClick={handleMain} target="_self" rel="noopener noreferrer">: หน้าหลัก</a> },
      {key: '/Help', icon: <QuestionCircleOutlined />, label: <a onClick={onclickManual} target="_self" rel="noopener noreferrer">: คู่มือการใช้งาน</a>},
      { key: '/logout', icon: <LogoutOutlined />, label: <a onClick={()=>setopenMod(true)}>: ออกจากระบบ</a> },
      { key: '/sss', label: <hr /> , disabled:true},
      { key: 'set', icon: <AppstoreOutlined />, label: <p>ข้อมูลโครงการ</p>,children:[
        {key: '/part1', icon: <BookOutlined />, label: <a href={`/VRIIS/BudgetReqInfo/${project_id}#part-1`}><ArrowRightOutlined /> ส่วนที่ 1 ข้อมูลงานวิจัย</a>},
        {key: '/part2', icon: <UserOutlined />, label: <a href={`/VRIIS/BudgetReqInfo/${project_id}#part-2`}><ArrowRightOutlined /> ส่วนที่ 2 ข้อมูลบุคลากรที่เกี่ยวข้องกับงานวิจัย</a>},
        { key: '/part3', icon: <CopyOutlined />, label: <a href={`/VRIIS/BudgetReqInfo/${project_id}#part-3`}><ArrowRightOutlined /> ส่วนที่ 3 รายละเอียดโครงการงานวิจัย</a> },
        { key: '/part4', icon: <ProjectOutlined />, label: <a href={`/VRIIS/BudgetReqInfo/${project_id}#part-4`}><ArrowRightOutlined /> ส่วนที่ 4 ผลลัพธ์และผลกระทบ</a>},
        { key: '/part5', icon: <DollarOutlined />, label: <a href='#part-5'><ArrowRightOutlined /> ส่วนที่ 5 งบประมาณและค่าใช้จ่าย</a> },
      ]}])
  ;

  let ProjectUpdateInfoitems = 
    ([
      { key: '/VRIIS', icon: <HomeFilled />, label: <a onClick={handleMain} target="_self" rel="noopener noreferrer">: หน้าหลัก</a> },
      {key: '/Help', icon: <QuestionCircleOutlined />, label: <a onClick={onclickManual} target="_self" rel="noopener noreferrer">: คู่มือการใช้งาน</a>},
      { key: '/logout', icon: <LogoutOutlined />, label: <a onClick={()=>setopenMod(true)}>: ออกจากระบบ</a> },
      { key: '/sss', label: <hr /> , disabled:true},
      { key: 'set', icon: <AppstoreOutlined />, label: <p>ข้อมูลโครงการ</p>,children:[
        {key: '/part1', icon: <BookOutlined />, label: <a href={`/VRIIS/BudgetReqInfo/${project_id}#part-1`}><ArrowRightOutlined /> ส่วนที่ 1 ข้อมูลงานวิจัย</a>},
        {key: '/part2', icon: <UserOutlined />, label: <a href={`/VRIIS/BudgetReqInfo/${project_id}#part-2`}><ArrowRightOutlined /> ส่วนที่ 2 ข้อมูลบุคลากรที่เกี่ยวข้องกับงานวิจัย</a>},
        { key: '/part3', icon: <CopyOutlined />, label: <a href={`/VRIIS/BudgetReqInfo/${project_id}#part-3`}><ArrowRightOutlined /> ส่วนที่ 3 รายละเอียดโครงการงานวิจัย</a> },
        { key: '/part4', icon: <ProjectOutlined />, label: <a href={`/VRIIS/BudgetReqInfo/${project_id}#part-4`}><ArrowRightOutlined /> ส่วนที่ 4 ผลลัพธ์และผลกระทบ</a>},
        { key: '/part5', icon: <DollarOutlined />, label: <a href='#part-5'><ArrowRightOutlined /> ส่วนที่ 5 งบประมาณและค่าใช้จ่าย</a> },
      ]},
      { key: '/progresscheck', icon: <FileSearchOutlined />, label: <a onClick={handleCheckUpdated}>: รายงานความก้าวหน้าโครงงานวิจัย</a> },
      { key: '/completioncheck', icon: <ScheduleOutlined />, label: <a onClick={handleCheckComplete}>: ปิดโครงการ</a> },
    ])
  ;

  let ProjectUpdateStudentInfoitems = 
    ([
      { key: '/VRIIS', icon: <HomeFilled />, label: <a onClick={handleMain} target="_self" rel="noopener noreferrer">: หน้าหลัก</a> },
      {key: '/Help', icon: <QuestionCircleOutlined />, label: <a onClick={onclickManual} target="_self" rel="noopener noreferrer">: คู่มือการใช้งาน</a>},
      { key: '/logout', icon: <LogoutOutlined />, label: <a onClick={()=>setopenMod(true)}>: ออกจากระบบ</a> },
      { key: '/sss', label: <hr /> , disabled:true},
      { key: 'set', icon: <AppstoreOutlined />, label: <p>ข้อมูลโครงการ</p>,children:[
        {key: '/part1', icon: <BookOutlined />, label: <a href={`/VRIIS/BudgetReqInfo/${project_id}#part-1`}><ArrowRightOutlined /> ส่วนที่ 1 ข้อมูลงานวิจัย</a>},
        {key: '/part2', icon: <UserOutlined />, label: <a href={`/VRIIS/BudgetReqInfo/${project_id}#part-2`}><ArrowRightOutlined /> ส่วนที่ 2 ข้อมูลบุคลากรที่เกี่ยวข้องกับงานวิจัย</a>},
        { key: '/part3', icon: <CopyOutlined />, label: <a href={`/VRIIS/BudgetReqInfo/${project_id}#part-3`}><ArrowRightOutlined /> ส่วนที่ 3 รายละเอียดโครงการงานวิจัย</a> },
        { key: '/part4', icon: <ProjectOutlined />, label: <a href={`/VRIIS/BudgetReqInfo/${project_id}#part-4`}><ArrowRightOutlined /> ส่วนที่ 4 ผลลัพธ์และผลกระทบ</a>},
        { key: '/part5', icon: <DollarOutlined />, label: <a href='#part-5'><ArrowRightOutlined /> ส่วนที่ 5 งบประมาณและค่าใช้จ่าย</a> },
      ]},
      { key: '/completioncheck', icon: <ScheduleOutlined />, label: <a onClick={handleCheckComplete}>: ปิดโครงการ</a> },
    ])
  ;

  //หน้าฟอร์ม
  const FormMenuItems = [
    { key: '/', icon: <HomeFilled />, label: <a onClick={handleMain} target="_self" rel="noopener noreferrer">: หน้าหลัก</a> },
    {key: '/Help', icon: <QuestionCircleOutlined />, label: <a onClick={onclickManual} target="_self" rel="noopener noreferrer">: คู่มือการใช้งาน</a>},
    { key: '/logout', icon: <LogoutOutlined />, label: <a onClick={()=>setopenMod(true)}>: ออกจากระบบ</a> },
    { key: '/sss', label: <hr /> , disabled:true},
    { key: '/main', icon: <CopyOutlined /> , label: <a href={`/VRIIS/BudgetReqInfo/${project_id}`}> ข้อมูลงานวิจัยที่กรอกไปแล้ว </a> },
    {
      key: '/part1', 
        icon: <BookOutlined />, 
        label: <a href={`/VRIIS/Budget_req_About/${project_id}`}><ArrowRightOutlined /> ส่วนที่ 1 ข้อมูลงานวิจัย</a> 
    },{ 
      key: '/part2', 
      icon: <UserOutlined />, 
      label: <a href={`/VRIIS/BudgetReqResearcher/${project_id}`}><ArrowRightOutlined /> ส่วนที่ 2 ข้อมูลบุคลากรที่เกี่ยวข้องกับงานวิจัย</a> 
    },{
      key: '/part3', 
      icon: <CopyOutlined />, 
      label: <a href={`/VRIIS/BudgetReqDetail/${project_id}`} ><ArrowRightOutlined /> ส่วนที่ 3 รายละเอียดโครงการงานวิจัย</a> 
    },
    { 
      key: '/part4', 
      icon: <ProjectOutlined />, 
      label: <a href={`/VRIIS/BudgetReqResult/${project_id}`}><ArrowRightOutlined /> ส่วนที่ 4 ผลลัพธ์และผลกระทบ</a> 
    },
    { 
      key: '/part5', 
      icon: <DollarOutlined />, 
      label: <a href={`/VRIIS/BudgetReqFund/${project_id}`}><ArrowRightOutlined /> ส่วนที่ 5 งบประมาณและค่าใช้จ่าย</a> 
    },

  ];

  
  //หน้าฟอร์มส่วนที่3
  const DetailItems = [
    { key: '/', icon: <HomeFilled />, label: <a onClick={handleMain} target="_self" rel="noopener noreferrer">: หน้าหลัก</a> },
    {key: '/Help', icon: <QuestionCircleOutlined />, label: <a onClick={onclickManual} target="_self" rel="noopener noreferrer">: คู่มือการใช้งาน</a>},
    { key: '/logout', icon: <LogoutOutlined />, label: <a onClick={()=>setopenMod(true)}>: ออกจากระบบ</a> },
    { key: '/sss', label: <hr /> , disabled:true},
    { key: '/main', icon: <CopyOutlined /> , label: <a href={`/VRIIS/BudgetReqInfo/${project_id}`}> ข้อมูลงานวิจัยที่กรอกไปแล้ว </a> },
    {
      key: '/part1', 
        icon: <BookOutlined />, 
        label: <a href={`/VRIIS/Budget_req_About/${project_id}`}><ArrowRightOutlined /> ส่วนที่ 1 ข้อมูลงานวิจัย</a> 
    },{ 
      key: '/part2', 
      icon: <UserOutlined />, 
      label: <a href={`/VRIIS/BudgetReqResearcher/${project_id}`}><ArrowRightOutlined /> ส่วนที่ 2 ข้อมูลบุคลากรที่เกี่ยวข้องกับงานวิจัย</a> 
    },{
      key: '/part3', 
      icon: <CopyOutlined />, 
      label: <a href={`/VRIIS/BudgetReqDetail/${project_id}`} ><ArrowRightOutlined /> ส่วนที่ 3 รายละเอียดโครงการงานวิจัย</a> 
    },
    { 
      key: '/part4', 
      icon: <ProjectOutlined />, 
      label: <a href={`/VRIIS/BudgetReqResult/${project_id}`}><ArrowRightOutlined /> ส่วนที่ 4 ผลลัพธ์และผลกระทบ</a> 
    },
    { 
      key: '/part5', 
      icon: <DollarOutlined />, 
      label: <a href={`/VRIIS/BudgetReqFund/${project_id}`}><ArrowRightOutlined /> ส่วนที่ 5 งบประมาณและค่าใช้จ่าย</a> 
    },
    { key: '/sss', label: <hr /> , disabled:true},
           {key: 'set', icon: <AppstoreOutlined />, label: <p>สารบัญรายละเอียดโครงการวิจัย</p>,children:
            [ { key: 'benefit', icon: <StarOutlined />, label: <a href='#part-1'><ArrowRightOutlined /> ความสำคัญ / เหตุผล / ปัญหาที่สำคัญของงานวิจัย / นิยาม</a> },
            { key: 'part2', icon: <OrderedListOutlined />, label: <a href='#part-2'><ArrowRightOutlined /> วัตถุประสงค์ของงานวิจัย</a> },
            { key: 'part3', icon: <PlusCircleOutlined />, label: <a href='#part-3'><ArrowRightOutlined /> ประโยชน์ที่คาดว่าจะได้รับ</a> },
            { key: 'part4', icon: <FormOutlined />, label: <a href='#part-4'><ArrowRightOutlined /> กรอบแนวคิดในการวิจัย</a> },
            { key: 'part5', icon: <BarsOutlined />, label: <a href='#part-5'><ArrowRightOutlined /> ระเบียบวิธีวิจัย</a> },
            { key: 'part6', icon: <CalendarOutlined />, label: <a href='#part-6'><ArrowRightOutlined /> ระยะเวลาและแผนวิจัย</a> },
            { key: 'part7', icon: <ToolOutlined />, label: <a href='#part-7'><ArrowRightOutlined /> อุปกรณ์</a> }]}
  ]

  function checklist() {
    console.log('add');
    if(isHome||isHome2){
      setActive(false);
    }
    if (project_id) {
      
      axios.get(`${process.env.REACT_APP_BASE}/BudgetReqInfo/${project_id}/${sessionStorage.getItem('user')}`)
        .then(response => {
          
          const newMenuItems = [{ key: '/VRIIS', icon: <HomeFilled />, label: <a onClick={handleMain} target="_self" rel="noopener noreferrer">: หน้าหลัก</a> },
            
            { key: '/logout', icon: <LogoutOutlined />, label: <a onClick={()=>setopenMod(true)}>: ออกจากระบบ</a> },
            { key: '/sss', label: <hr /> , disabled: true },
            { key: '/main', label: <a href={`/VRIIS/BudgetReqInfo/${project_id}`}> ข้อมูลงานวิจัยที่กรอกไปแล้ว </a> },
            { key: '/sss', label: <hr /> , disabled: true },];
          const newInfoMenu = [];
          newMenuItems.push({
            key: '/part1', 
              icon: <UserOutlined />, 
              label: <a href={`/VRIIS/Budget_req_About/${project_id}`}><ArrowRightOutlined /> ส่วนที่ 1 ข้อมูลงานวิจัย</a> 
          })
          newInfoMenu.push({key: '/part1', icon: <BookOutlined />, label: <a href={`/VRIIS/BudgetReqInfo/${project_id}#part-1`}><ArrowRightOutlined /> ส่วนที่ 1 ข้อมูลงานวิจัย</a>})
          if (response.data.main[0].sdgs && response.data.main[0].response && response.data.main[0]?.oecd_id && response.data.main[0].project_place) {
            newMenuItems.push({ 
              key: '/part2', 
              icon: <UserOutlined />, 
              label: <a href={`/VRIIS/BudgetReqResearcher/${project_id}`}><ArrowRightOutlined /> ส่วนที่ 2 ข้อมูลบุคลากรที่เกี่ยวข้องกับงานวิจัย</a> 
            });
            newInfoMenu.push({key: '/part2', icon: <UserOutlined />, label: <a href={`/VRIIS/BudgetReqInfo/${project_id}#part-2`}><ArrowRightOutlined /> ส่วนที่ 2 ข้อมูลบุคลากรที่เกี่ยวข้องกับงานวิจัย</a>})

          }
          
          if (response.data.main[0].resolution
            && response.data.main[0].objective_list
            && response.data.main[0].benefit
            && response.data.main[0].literacy
            && response.data.main[0].idea
            && response.data.main[0].solution
            && response.data.main[0].activity) {
            newMenuItems.push();
            newInfoMenu.push({ key: '/part4', icon: <ProjectOutlined />, label: <a href={`/VRIIS/BudgetReqInfo/${project_id}#part-4`}><ArrowRightOutlined /> ส่วนที่ 4 ผลลัพธ์และผลกระทบ</a>})
          }
          if (response.data.main[0].output && response.data.main[0].outcome && response.data.main[0].impacts) {
            newMenuItems.push({ 
              key: '/part5', 
              icon: <DollarOutlined />, 
              label: <a href={`/VRIIS/BudgetReqFund/${project_id}`}><ArrowRightOutlined /> ส่วนที่ 5 งบประมาณและค่าใช้จ่าย</a> 
            });
            newInfoMenu.push(    { key: '/part5', icon: <DollarOutlined />, label: <a href='#part-5'><ArrowRightOutlined /> ส่วนที่ 5 งบประมาณและค่าใช้จ่าย</a> },)
          }
          if(response.data.main[0].project_status=='อนุมัติ'&&
            response.data.main[0].ApprovalStatus!='ปิดโครงการ'){
            SetApproved(true)
            if(response.data.main[0].budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'){
              setIsStudent(true)
            }
          }
          
          
          // Update the state with the new menu items
          let tmp: MenuItem[] = [
            { key: '/', icon: <HomeFilled />, label: <a onClick={handleMain} target="_self" rel="noopener noreferrer">: หน้าหลัก</a> },
            { key: '/logout', icon: <LogoutOutlined />, label: <a onClick={()=>setopenMod(true)}>: ออกจากระบบ</a> },
            { key: '/sss', label: <hr /> , disabled: true }]
          
          
          setActive(false);
        })
        ;
      
        
    }else{
      setActive(false);
    }
    
  }
  
  useEffect(() => {
    checklist(); 
    
    const setFavicon = (iconUrl: string) => {
      const link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
      if (link) {
        link.href = iconUrl;
      } else {
        const newLink = document.createElement("link");
        newLink.rel = "icon";
        newLink.href = iconUrl;
        document.head.appendChild(newLink);
      }
    };

    // Set external image URL as favicon
    setFavicon("https://www.vu.ac.th/wp-content/uploads/elementor/thumbs/vu-main-logo-02-qtm90eapvkc9aj8bjqi1ltncwx61v3ygsveunoi0mu.png");
    document.title = "VRIIS"; 
    
     
  }, [location.pathname]);
  return (
    
    <LoadingOverlay
      active={isActive}
      spinner
      text='กำลังโหลดข้อมูล'
    >
              
    <ConfigProvider 
      theme={{
        components: {
          Table: {
            bodySortBg:"",
            headerBg:"#8EA3A6",
            rowHoverBg:"#E6E9AF",
            footerBg:"#8EA3A6",
            headerColor:"white"
          },
          Menu: {
            fontFamily: 'kanit',
            itemBg: "#white",
            itemColor: "#FFDBB5",
            itemHoverColor: "#4158A6",
            itemSelectedBg: "#FFDBB5",
            itemSelectedColor: "#8174A0",
          },
          Layout: {
            siderBg: "#5c5582",
            headerBg: "#FFD3B6",
          },
          Input: {
            activeBg: 'white',
            hoverBg: 'white',
          },
          Select: {
            optionSelectedColor: '#8174A0',
            optionActiveBg: "#E5E1DA",
            controlItemBgActive: '#E5E1DA'
        },
        },
        token: {
          fontSize: 16,
          fontFamily: 'Kanit',
          colorBgBase: '#BAB4DE',
          colorBgContainer: 'F7DCB9',
          colorBgElevated: 'white',
          colorBorder: "#179BAE",
        }
      }}
    >
      <title>VRIIS</title>
      <Layout>
      
        <Sider
          width={'40vh'}
          style={siderStyle}
          trigger={null}
          collapsible
          collapsed={collapsed}
        >
          <br/>
          <Flex justify='center'>
            <img src={R} alt="Logos" />
          </Flex>

          {/* หน้าหลัก/ดราฟท์ */}
          {(isHome||isDraft||isHome2) && (
            <Menu
              mode='inline'
              defaultSelectedKeys={[MenuKey]}
              items={items}
              style={{ padding: 10 }}
            />
          )}
          {/* หน้าข้อมูล */}
          {((isBudgetReqInfo
            ||IsProgressReport
            ||IsProgressReport2
            ||IsProgressCheckReport
            ||IsProgressReportEdit
            ||IsCompletionReport
            ||IsCompletionCheckReport)&&
            (!isHome&&!isHome2&&!isDraft))
            &&
            <>
          {(Approved)&&<>
            {IsStudent&&
              <Menu
              mode='inline'
                defaultSelectedKeys={[MenuKey]}
                items={Infoitems}
                // items={ProjectUpdateStudentInfoitems}

                defaultOpenKeys={['set']}
                style={{ padding: 10 }}
              />
            ||<Menu
            mode='inline'
              defaultSelectedKeys={[MenuKey]}
              items={Infoitems}
              // items={ProjectUpdateInfoitems}

              defaultOpenKeys={['set']}
              style={{ padding: 10 }}
            />}</>||
            (
              <Menu
              mode='inline'
                defaultSelectedKeys={[MenuKey]}
                items={Infoitems}
                defaultOpenKeys={['set']}
                style={{ padding: 10 }}
              />
            )}</>
          }

          {/* หน้าฟอร์ม */}
          {(!isHome
          &&!isBudgetReqDetail
          &&!isDraft
          &&!isBudgetReqInfo
          &&!isHome2
          &&!IsProgressReport
          &&!IsProgressReportEdit
          &&!IsProgressCheckReport
          &&!IsCompletionReport
          &&!IsCompletionCheckReport) && (
            <Menu
              mode='inline'
              defaultSelectedKeys={[MenuKey]}
              items={FormMenuItems}
              style={{ padding: 10 }}
              
            />
          )}

          {isBudgetReqDetail && (
            <Menu
              mode='inline'
              defaultSelectedKeys={[MenuKey]}
              items={DetailItems}
              style={{ padding: 10 }}
            />
          )}
        </Sider>

        <Layout
          style={{
            marginLeft: collapsed ? '80px' : '40vh', // Adjust margin based on sidebar state
            transition: 'margin-left 0.2s', // Smooth transition when collapsing
          }}
        >
          <Header
            style={{
              position: 'fixed',
              top: 0,
              left: collapsed ? '80px' : '40vh', // Match the Sider's width when collapsed or expanded
              width: `calc(100% - ${collapsed ? '80px' : '40vh'})`, // Adjust width dynamically
              zIndex: 1001,
              padding: '0 16px', // Add padding for alignment
              background: '#8EA3A6',
              height: '64px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              transition: 'left 0.3s, width 0.3s', // Smooth transitions
            }}
          >
            {/* Left Section */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={() => setCollapsed(!collapsed)}
                style={{
                  fontSize: '16px',
                  width: 64,
                  height: 64,
                }}
              />
              <p style={{ color: 'white', margin: 0 }}>
                📂 ระบบยื่นขอทุนวิจัยและนวัตกรรม มหาวิทยาลัยวงษ์ชวลิตกุล
              </p>
            </div>

            {/* Right Section */}
            <Dropdown overlay={ <Menu>
              <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={() => setopenMod(true)}>
                ออกจากระบบ
              </Menu.Item>
            </Menu>} trigger={['click']}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
              <img
                src={sessionStorage.getItem('user_picture') || imgdata}
                alt="User"
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  objectFit: 'cover',
                }}
              />
              <p style={{ color: 'white', margin: 0 }}>{sessionStorage.getItem('fullname')}</p>
            </div>
          </Dropdown>
          </Header>

          <Content
            style={{
              margin: '25px 70px',
              padding: 24,
              minHeight: '88vh',
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
              marginTop: '64px', // Matches the height of the Header
              overflow: 'auto', // Prevent content overflow
            }}
          >
            
            <Outlet />
            <FloatButton.BackTop />
            <Modal
              title="ยืนยันการออกจากระบบ"
              open={openMod}
              onCancel={()=>setopenMod(false)}
              footer={[
                <><Button key="back" onClick={()=>setopenMod(false)}>
                    กลับ
                </Button><Button type='primary' danger onClick={() => signout()}>
                    ใช่
                </Button></>
              ]}
            >
              คุณต้องการออกจากระบบใช่หรือไม่
            </Modal>
          </Content>
        </Layout>
      </Layout>
    </ConfigProvider>
    </LoadingOverlay>
  );
};

export default Navbar;
